module.exports = __webpack_public_path__ + "img/logo_solidaridad.988cafe0.png";